import React, {Component} from 'react'
import PropTypes from 'prop-types'
import convertNumberRound from "../../../../helpers/convertNumberRound";

class WeightColumn extends Component {
    render() {
        const {weight, volume} = this.props

        return <td className="WeightNet">
            {convertNumberRound(weight, 2)} / {convertNumberRound(volume, 2)}
        </td>
    }
}

WeightColumn.propTypes = {
    weight: PropTypes.number,
    volume: PropTypes.number
}

export default WeightColumn